import React, { Fragment, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import Toast from "../../toast/SetToast";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import { db } from "../../../../firebase";
import { setDoc, getDoc, updateDoc, doc, collection } from "firebase/firestore";
import { CPAPServiceEditForm } from "./CPAPServiceEditForm";
import { useFirestore } from "../../../../hook/useFirestore";

const CPAPServiceEdit = (props) => {
  const { updateDocument } = useFirestore("cpapService");
  const inputRef = useRef({
    brand: "",
    model: "",
    withHumidifier: "",
    price: "",
    humidifierPrice: "",
    tubePrice: "",
    rentalPrice: "",
    IsActive: "",
  });

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      brand: inputRef.current.brand ? inputRef.current.brand : props.item.brand,
      model: inputRef.current.model ? inputRef.current.model : props.item.model,
      withHumidifier: inputRef.current.withHumidifier
        ? inputRef.current.withHumidifier
        : props.item.withHumidifier,
      price: inputRef.current.price ? inputRef.current.price : props.item.price,
      humidifierPrice: inputRef.current.humidifierPrice
        ? inputRef.current.humidifierPrice
        : props.item.humidifierPrice,
      tubePrice: inputRef.current.tubePrice
        ? inputRef.current.tubePrice
        : props.item.tubePrice,
      rentalPrice: inputRef.current.rentalPrice
        ? inputRef.current.rentalPrice
        : props.item.rentalPrice,
      IsActive: inputRef.current.IsActive
        ? inputRef.current.IsActive
        : props.item.IsActive,
    };

    updateDocument(props.item.id, formData)
      .then(() => {
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      })
      .catch((err) => {
        notifyError("บันทึกข้อมูลผิดพลาด ", err);
      });

    props.hide();

    // Reset form fields
    inputRef.current.brand = "";
    inputRef.current.model = "";
    inputRef.current.withHumidifier = "";
    inputRef.current.price = "";
    inputRef.current.humidifierPrice = "";
    inputRef.current.tubePrice = "";
    inputRef.current.rentalPrice = "";
    inputRef.current.IsActive = "";
  };

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Edit CPAP Service</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CPAPServiceEditForm
            onChange={handleChange}
            initailValues={props.item}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>

          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default CPAPServiceEdit;
